/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ChannelListMagnifyingGlassIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABDUlEQVR4nO1TS05CQRB8GzREWZpwH3jmxdDd5aLpXrh+RzCKxotwEVdqNFxAIbjUCxgWuNYMPBXCJ+iwkVDJLKYzqUpV9STJFquC4B2Gf6zliD3MCIThugQIfp9sHmjbwf/rQObs+jL89h/QRuy6qu4w7ILF+gx7I3iPxFp5npf+1oH85J5l2e7CWMXuZkRW6YAmcmf4ZUH20hCrpenJHnOzzvDX4u15VDwE7wWiQD41P/Z0LGCPUQIMGwYiVd2fmjNXRgLig6gOCP48mnGzPs8Bw7qRHdjZVweBNDhpwA6/OxBrRa8owa6XuO0fqVZjRcokfsriTwx/H8dmV8U9OL6JEliETPWA4LcEa38CJcCQlNaazUsAAAAASUVORK5CYII=)
 */
export const ChannelListMagnifyingGlassIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M18.5 23c.88 0 1.7-.25 2.4-.69l1.4 1.4a1 1 0 0 0 1.4-1.42l-1.39-1.4A4.5 4.5 0 1 0 18.5 23Zm0-2a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"
        clipRule="evenodd"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
      <path
        d="M3 3a1 1 0 0 0 0 2h18a1 1 0 1 0 0-2H3ZM2 8a1 1 0 0 1 1-1h18a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 11a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2H3ZM2 16a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1ZM3 19a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H3Z"
        fill={typeof color === 'string' ? color : color.css}
        className={colorClass}
      />
    </svg>
  );
};
